import React, { useCallback, useEffect, useState } from 'react'
import {Alert} from '@material-ui/lab';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import FolderIcon from '@material-ui/icons/Folder';
import DescriptionIcon from '@material-ui/icons/Description';
import DeleteIcon from '@material-ui/icons/Delete';
import PublishIcon from '@material-ui/icons/Publish';
import ShareIcon from '@material-ui/icons/Share';

import GetAppIcon from '@material-ui/icons/GetApp';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import {useDropzone} from 'react-dropzone'
import TextField from '@material-ui/core/TextField';
const prettyBytes = require('pretty-bytes');

const axios = require('axios');

const publicUrl = process.env.REACT_APP_GOZ_PUBLIC_URL || '';
const backend = process.env.REACT_APP_GOZ_BACKEND_URL || publicUrl

const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },

    dropzone: {
        backgroundColor: 'lightGrey',
    },

    flexform: {
        display: 'flex',
        flexDirection: 'row',
    }
});

const FileShareDialog = (props) => {
    const classes = useStyles();
    const { onClose, open } = props;
  
    const handleClose = () => {
      setLink("")
      onClose();
    };

    const [errMsg, setErrMsg] = useState('')
    const [link, setLink] = useState('')
    //const [access, setAccess] = useState('ro')
    const [duration, setDuration] = useState(30)


    const getlink = () => {
        let f = props.file;
        if (f[0] !== "/") {
            f = "/" + f;
        }
        let token = props.token;
        axios.get(`${backend}/api/s3share/${props.project}/${props.bucket}${f}`, {
            params: {
                duration: parseInt(duration) * 24 * 3600,
            },
            headers: {
                'X-Auth-Token': token
            }
        }).then(resp => {
            // console.log('link', resp.data)
            setLink(resp.data.Link)
            setErrMsg('')
        }).catch(err => {
            setErrMsg(err.message)
        })
    }
      return (<React.Fragment>
         {props.file &&
          <Dialog onClose={handleClose} aria-labelledby="file information dialog" open={open} maxWidth="lg" fullWidth={true}>
            <DialogTitle id="file-information-title">{props.file}</DialogTitle>
        {errMsg && <Alert severity="error">{errMsg}</Alert>}
                <FormControl className={classes.form}>
                <InputLabel  htmlFor="my-duration">Duration (days)</InputLabel>
                <Input id="my-duration" onChange={(e) => setDuration(e.target.value)} value={duration}/>
                </FormControl>
                <Button className={classes.form} variant="contained" color="primary" onClick={() => getlink()}>Get link</Button>

                <TextField className={classes.form} disabled value={link} id="outlined-basic" label="Share link" variant="outlined"/>
          </Dialog>
        }
        </React.Fragment>)
}



const S3Browser = (props) => {

    const classes = useStyles()

    const [errMsg, setErrMsg] = useState('')
    const [loading, setLoading] = useState(false)
    const [swift, setSwift] = useState('')

    const [s3Token, setS3Token] = useState(null)
    const [project, setProject] = useState('')
    const [buckets, setBuckets] = useState([])
    const [bucket, setBucket] = useState('')
    const [bucketMeta, setBucketMeta] = useState({})
    const [files, setFiles] = useState([])
    const [dir, setDir] = useState('')
    const [fileShare, setFileShare] = useState(null)

    const [s3User, setS3User] = useState({
      user: "",
      password: "",
      project: ""
    })

    const [newBucket, setNewBucket] = useState('')


    const handleFileShareClose = (value) => {
        setFileShare(null)
    }

    const shareAccess = (f) => {
        let dest = `${dir}${f.Name}`
        // console.log('should share', dest)
        setFileShare(dest)
    }

    useEffect(() => {
        if(s3Token === null || !bucket) {
            return
        }
        getBucketFiles(project, bucket, dir, s3Token)
    }, [dir, bucket, s3Token, project])

    useEffect(() => {
        if (s3Token === null) {
            setBucket('')
            setBuckets([])
            setDir('')
        }
    },[s3Token])

    useEffect(() => {
        if (bucket === '' || project === '' || s3Token === null) {
            return
        }
        // console.debug('bucket changed', bucket)
        getBucketFiles(project, bucket, '', s3Token)
        getBucketMeta(project, bucket)
    }, [bucket, project, s3Token])



    useEffect(() => {
        let t = localStorage.getItem("goz-s3token");
        let p = localStorage.getItem("goz-s3project")
        if(t && p) {
            setS3Token(t)
            setProject(p)
            setSwift(localStorage.getItem("goz-s3url"))
            getBuckets(p, t)
        }
    }, [])

    const getBucketMeta = (project, bucket) => {
        axios.get(`${backend}/api/s3meta/${project}/${bucket}`, {
            'headers': {
                'X-Auth-Token': s3Token
            }
        }).then((response) => {
           // console.log('bucket meta', response.data)
           setBucketMeta(response.data.Bucket)
        }).catch(err  => {
            setErrMsg(err.message)
            if(err.response.status === 401) {
                logout2s3()
            }
        });
    }

    const updateBucketMetaPublic = (project, bucket, is_public) => {
        axios.post(`${backend}/api/s3meta/${project}/${bucket}`, null, {
            'headers': {
                'X-Auth-Token': s3Token
            },
            params: {
                public: is_public
            }
            
        }).then((response) => {
           setBucketMeta({...bucketMeta, "X-Container-Read": is_public})
        }).catch(err  => {
            setErrMsg(err.message)
            if(err.response.status === 401) {
                logout2s3()
            }
        });
    }

    const updateBucketMetaWeb = (project, bucket, web) => {
        axios.post(`${backend}/api/s3meta/${project}/${bucket}`, null, {
            'headers': {
                'X-Auth-Token': s3Token
            },
            params: {
                web: web
            }
            
        }).then((response) => {
            setBucketMeta({...bucketMeta, "X-Container-Meta-Web-Listings": web})
        }).catch(err  => {
            setErrMsg(err.message)
            if(err.response.status === 401) {
                logout2s3()
            }
        });
    }


    // TODO temp url with prefix https://docs.openstack.org/swift/latest/api/temporary_url_middleware.html

    const isBucketPublic= () => {
        if (bucketMeta["X-Container-Read"]) {
            return true
        }
        return false
    }

    const isBucketWeb = () => {
        if (bucketMeta["X-Container-Meta-Web-Listings"]) {
            return true
        }
        return false
    }

    const logout2s3 = () => {
        setS3Token(null);
        localStorage.removeItem("goz-s3token")
        localStorage.removeItem("goz-s3project")

    }
    const log2s3 = () => {
        // console.log('should get token from s3')
        axios.post(`${backend}/api/s3auth`, s3User).then((response) => {
            setS3Token(response.data.Token)
            localStorage.setItem("goz-s3token", response.data.Token)
            localStorage.setItem("goz-s3project", response.data.Project)
            localStorage.setItem("goz-s3url", response.data.URL)
            setProject(response.data.Project)
            setS3User({...s3User, password: ''})
            getBuckets(response.data.Project, response.data.Token)
            setSwift(response.data.URL)
        }).catch(err  => {
            setErrMsg(err.message)
        });
    
    }

    const getBuckets = (project, token) => {
        axios.get(`${backend}/api/s3/${project}`, {
            'headers': {
                'X-Auth-Token': token
            }
        }).then((response) => {
            setBuckets(response.data.Buckets)
            if(!bucket && response.data.Buckets.length>0) {
                setBucket(response.data.Buckets[0].name)
            }
        }).catch(err  => {
            setErrMsg(err.message)
            if(err.response.status === 401) {
                logout2s3()
            }
        });  
    }

    const getBucketFiles = (project, bucket, path, token) => {
        setLoading(true)

        axios.get(`${backend}/api/s3/${project}/${bucket}${path}`, {
            'headers': {
                'X-Auth-Token': token
            }
        }).then((response) => {
            let tmp_files = [];
            let tmp_dir = dir.substring(1);
            for(let i=0;i<response.data.Files.length;i++) {
                let s3 = response.data.Files[i]
                let s3file = {
                    Size: s3.bytes || 0,
                    Dir: s3.subdir !== undefined ? true: false,
                    Name: (s3.subdir || s3.name).replace(tmp_dir, ''),
                    Date: s3.last_modified || ''

                }
                tmp_files.push(s3file)
            }
            setFiles(tmp_files)
            setLoading(false)
            setErrMsg('')
        }).catch(err  => {
            setErrMsg(err.message)
            setLoading(false)
            if(err.response.status === 401) {
                logout2s3()
            }
        });  
    }


    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.forEach((file) => {
            if(props.upload) {
                let backend = `${swift}/v1/AUTH_${project}/${bucket}`
                props.upload(backend, file, dir, s3Token);
            }
        })
        
      }, [dir, project, props, bucket, swift, s3Token])
    const {getRootProps, getInputProps} = useDropzone({onDrop})


    const goto = (dir, fileinfo) => {
        if (fileinfo === null) {
            setDir(dir)
            return
        }
        let path = fileinfo.Name;
        if (!fileinfo.Dir) {
            return
        }
        //setDir(`${dir}/${f.Name}`)
        // console.log('goto request', dir, path)
        let dest = `${path}`
        if (path === '..') {
            let dirs = dir.split('/')
            // console.log('goto', dirs.slice(0, dirs.length-2).join('/') + '/')
            // Should check if subdir is a base share, else prevent
            setDir(dirs.slice(0, dirs.length-2).join('/') + '/')
            return
        }
        if (dir[dir.length-1] !== "/") {
            dest = `${dir}/${path}`
        } else {
            dest = `${dir}${path}`
        }
        setDir(dest)
        // console.log('goto', dir, path, dest)
    }

    const fileType = (isDir) => {
        if (isDir) {
            return (<FolderIcon/>)
        }
        return (<DescriptionIcon/>)
    }


    const deleteFile = (fileInfo) => {
        let path = fileInfo.Name;
        if(fileInfo.Dir) {
            setErrMsg('not a file')
            return
        }

        let dest = `${path}`
        if (dir[dir.length-1] !== "/") {
            dest = `${dir}/${path}`
        } else {
            dest = `${dir}${path}`
        }
        
        axios.delete(`${swift}/v1/AUTH_${project}/${bucket}${dest}`,
            {
                headers: {
                    'X-Auth-Token': s3Token,
                }
            }
        ).then((response) => {
            getBucketFiles(project, bucket, dir, s3Token)
        }).catch(err  => {
            console.error(err)
            if(err.response.status === 401) {
                logout2s3()
            }
        });    
    }

    

    const downloadFile = (fileInfo) => {
        let path = fileInfo.Name;
        if(fileInfo.Dir) {
            setErrMsg('not a file')
            return
        }

        let dest = `${path}`
        if (dir[dir.length-1] !== "/") {
            dest = `${dir}/${path}`
        } else {
            dest = `${dir}${path}`
        }

        axios({
            url: `${swift}/v1/AUTH_${project}/${bucket}${dest}`,
            method: 'GET',
            responseType: 'blob', // important
            headers: {
                'X-Auth-Token': s3Token,
            }
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileInfo.Name); //or any other extension
            document.body.appendChild(link);
            link.click();
        }).catch(err  => {
            console.error(err);
            /*
            if(err.response.status === 401) {
                logout2s3()
            }*/
        });    
    }

    const createBucket = () => {
        axios.put(`${swift}/v1/AUTH_${project}/${newBucket}`, null,
            {
                headers: {
                    'X-Auth-Token': s3Token,
                }
            }
        ).then((response) => {
            getBuckets(project, s3Token)
        }).catch(err  => {
            console.error(err)
            setErrMsg(err.message)
            if(err.response.status === 401) {
                logout2s3()
            }
        }); 
        setNewBucket('')
    }

    return (
        <React.Fragment>
        {errMsg && <Alert severity="error">{errMsg}</Alert>}
        {loading && <Alert severity="info">Loading...</Alert>}

        {dir && <Alert severity="info">{dir}</Alert>}
        {s3Token === null && <Box className="left-action">
        <Grid container spacing={2}>
            <Grid item xs={12}>
            <FormControl>
            <InputLabel htmlFor="my-user">User id</InputLabel>
            <Input id="my-user" onChange={(e) => setS3User({...s3User, user: e.target.value})} value={s3User.user}/>
            </FormControl>
            </Grid>
            <Grid item xs={12}>
            <FormControl>
            <InputLabel htmlFor="my-password">Password</InputLabel>
            <Input type="password" id="my-password" onChange={(e) => setS3User({...s3User, password: e.target.value})} value={s3User.password}/>
            </FormControl>
            </Grid>
            <Grid item xs={12}>
            <FormControl>
            <InputLabel htmlFor="my-project">Project</InputLabel>
            <Input id="my-project" onChange={(e) => setS3User({...s3User, project: e.target.value})} value={s3User.project}/>
            </FormControl>
            </Grid>
            <Grid item xs={12}>
            <FormControl>
            <Button variant="contained" color="primary" onClick={()=>log2s3()}>Log in</Button>
            </FormControl>
            </Grid>
        </Grid>
        </Box>}
        {s3Token !== null && <Grid container>
            <Grid item xs={12}><Button variant="contained" color="primary" onClick={()=> logout2s3()}>Logout from {project}</Button></Grid>
            <Grid item xs={12}>
            <Grid container>
            <Grid item xs={12}>
                <Card variant="outlined"><CardContent>
                    {buckets.map(b => (
                        <Button size="small" onClick={() => setBucket(b.name)} className="left-action" variant="contained" color="secondary" key={b.name}>{b.name} [{b.count}][{prettyBytes(b.bytes)}]</Button>
                    ))}
                    <FormControl size="small" className={classes.flexform}>
                        <InputLabel htmlFor="my-bucket">Bucket name</InputLabel>
                        <Input id="my-bucket" onChange={(e) => setNewBucket(e.target.value)} value={newBucket}/>
                        <Button size="small" variant="contained" color="secondary" onClick={() => createBucket()}>Create</Button>
                    </FormControl>
                </CardContent></Card>
            </Grid>
            {bucket && <Grid item xs={12}>
                <Card>
                <CardContent>
                <Typography variant="h5">{bucket}</Typography>
                <Grid container>
                <Grid item xs={6}>
                <Box m={2}><Typography variant="h6">Visibility</Typography></Box>
                { isBucketPublic() && <div><Button variant="contained" color="secondary" disabled>Public</Button><Button onClick={() => updateBucketMetaPublic(project, bucket, "false")} variant="contained" color="secondary">Make private</Button></div>}
                { !isBucketPublic() && <div><Button variant="contained" color="secondary" onClick={() => updateBucketMetaPublic(project, bucket, "true")} >Make public</Button><Button variant="contained" color="secondary" disabled>Private</Button></div>}
                </Grid>
                <Grid item xs={6}>
                <Box m={2}><Typography variant="h6">Web access</Typography></Box>
                { isBucketWeb() && <div>
                    <Button variant="contained" color="secondary" disabled>Enabled</Button>
                    <Button variant="contained" color="secondary" onClick={() => updateBucketMetaWeb(project, bucket, "false")}>Disable</Button>
                </div>}
                { !isBucketWeb() && <Box><Button variant="contained" color="secondary" onClick={() => updateBucketMetaWeb(project, bucket, "true")} >Enable</Button><Button variant="contained" color="secondary" disabled>Disabled</Button></Box>}
                </Grid>
                <Grid item xs={12}>
                    <Box m={5}>
                    <Alert severity="info">{swift}/v1/AUTH_{project}/{bucket}/</Alert>
                    </Box>
                </Grid>
                </Grid>
                </CardContent>
                </Card>
            </Grid>}
            </Grid>

            </Grid>
            <Grid item xs={12}>
                <Card className={classes.dropzone}><CardContent>
                    <div {...getRootProps()}>
                        <input {...getInputProps()} />
                        <p>Drag 'n' drop some files here, or click to select files</p>
                        <PublishIcon/>
                        
                    </div>
                </CardContent>
                </Card>
                <Box>
            <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="files">
                    <TableHead>
                    <TableRow>
                        <TableCell size="small">Type</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>Size</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell><Button variant="contained" color="primary" onClick={() => goto('', null)}>Back to root</Button></TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {dir !== "/" && <TableRow>
                        <TableCell size="small" onClick={() => goto(dir, {Name: '..', Dir: true})}>
                        {fileType(true)}
                        </TableCell>
                        <TableCell>..</TableCell>
                        <TableCell>0</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        </TableRow>
                    }
                    {files.map((f) => (
                        <TableRow key={f.Name}>
                        <TableCell size="small" onClick={() => goto(dir, f)}>
                        {fileType(f.Dir)}
                        </TableCell>
                        <TableCell>{f.Name}</TableCell>
                        <TableCell>{prettyBytes(f.Size)}</TableCell>
                        <TableCell>{f.Date}</TableCell>
                        <TableCell>
                            {!f.Dir && <GetAppIcon onClick={() => downloadFile(f)}/>}
                            {!f.Dir && <DeleteIcon onClick={() => deleteFile(f)}/>}
                            {<ShareIcon onClick={() => shareAccess(f)}/>}

                        </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                    </Table>
                    </TableContainer>



                </Box>
            </Grid>
        </Grid>}
        <FileShareDialog project={project} bucket={bucket} file={fileShare} token={s3Token} open={fileShare !== null} onClose={handleFileShareClose} />

        </React.Fragment>
    )
}

export default S3Browser;